import { AnyAction } from 'redux';
import * as constants from 'redux/constants/jewishness.constants';
import { ITableUpdate } from 'types/table.types';
import { IJewishnessFormData } from 'views/public/JewishnessView/components/JewishnessForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.JEWISHNESS_ON_DELETE_REQUESTED,
  id,
});

export const onDeleteFile = (id: string, fileId: string): AnyAction => ({
  type: constants.JEWISHNESS_ON_DELETE_FILE_REQUESTED,
  id,
  fileId,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.JEWISHNESS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.JEWISHNESS_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.JEWISHNESS_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IJewishnessFormData, id?: string): AnyAction => ({
  type: constants.JEWISHNESS_ON_SAVE_REQUESTED,
  formData,
  id,
});
